import { Button, Inline, Text } from "@softmax/design-system";
import { spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { PoliciesDirectoryState } from "./policy-directory-records";

export function PolicyDirectoryPagination({
  state,
  pending,
}: {
  readonly state: PoliciesDirectoryState;
  readonly pending: boolean;
}) {
  return (
    <div {...stylex.props(styles.pagination)}>
      <Text size="small" tone="muted">
        {state.status === "ready" &&
          `${state.rows.length.toLocaleString("en-US")} ${state.rows.length === 1 ? "policy" : "policies"} · `}
        Newest first
      </Text>
      <Inline>
        <Button
          size="sm"
          aria-disabled={
            state.status !== "ready" || state.cursor === null || pending
          }
          onClick={() => {
            if (state.status === "ready" && state.cursor !== null && !pending)
              state.onFirstPage();
          }}
        >
          First page
        </Button>
        <Button
          size="sm"
          aria-disabled={
            state.status !== "ready" || state.nextCursor === null || pending
          }
          onClick={() => {
            if (
              state.status === "ready" &&
              state.nextCursor !== null &&
              !pending
            )
              state.onNextPage();
          }}
        >
          Next
        </Button>
      </Inline>
    </div>
  );
}

const styles = stylex.create({
  pagination: {
    display: "flex",
    flexWrap: "wrap",
    gap: spacing.space12,
    justifyContent: "space-between",
    alignItems: "center",
  },
});
